import { render, staticRenderFns } from "./bulkSubAccountAcl.vue?vue&type=template&id=03223370&scoped=true&"
import script from "./bulkSubAccountAcl.vue?vue&type=script&lang=js&"
export * from "./bulkSubAccountAcl.vue?vue&type=script&lang=js&"
import style0 from "./bulkSubAccountAcl.vue?vue&type=style&index=0&id=03223370&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03223370",
  null
  
)

export default component.exports